import React, { useEffect, useState } from 'react'
import LoadingAbsolute from '../../LoadingAbsolute'
import Header from '../../Header'
import HistoryItem from './HistoryItem'
import axios from 'axios'
import Empty from '../../Empty'
import TubitakWarningModal from '../TUBITAKDergiForm/Modals/TubitakWarningModal'
import { useLocation, useNavigate } from 'react-router-dom'

const HistoryPage = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const navigate = useNavigate()
  const { state } = useLocation()

  const [warningModalOpen, setWarningModalOpen] = useState({
    state: '',
    active: false,
    message: '',
  })

  const getData = () => {
    setLoading(true)
    axios
      .get(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/etkinlik-bilet/listele`, {
        params: {
          token: JSON.parse(localStorage.getItem('token')),
        },
      })
      .then((res) => {
        setLoading(false)
        if (res.data.code === 200) {
          if (res.data.items?.length > 0) {
            setData(res.data.items?.reverse())
          }
        } else if (res.data.code === 400) {
          setWarningModalOpen({
            state: 'responseMessage',
            active: true,
            message: res.data.message,
          })
        }
      })
  }

  useEffect(() => {
    getData()
  }, [])

  const biletIptal = (bilet) => {
    setLoading(true)
    axios
      .post(`${process.env.REACT_APP_BASE_URL}/api/dijital_basvuru/etkinlik-bilet/iptal`, {
        token: JSON.parse(localStorage.getItem('token')),
        bilet_id: bilet.id,
      })
      .then((res) => {
        setLoading(false)
        setWarningModalOpen({
          state: 'responseMessage',
          active: true,
          message: res.data.code === 200 ? `${bilet.bilet_no} numaralı biletiniz iptal edildi.` : res.data.message,
        })
        getData()
      })
      .catch(() => {
        setLoading(false)
        setWarningModalOpen({ state: 'responseMessage', active: true, message: 'Bilet iptal edilemedi. Lütfen tekrar deneyiniz.' })
      })
  }

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar' style={{ marginTop: '1.5rem' }}>
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header onClick={() => (state ? navigate(-1) : navigate('/'))} />
        </div>
        {data?.length > 0 ? (
          data.map((item) => {
            return (
              <HistoryItem
                key={item.id}
                title={item.theatre_name}
                name={item.theatre_name}
                date={item.date}
                seans={item.hour}
                ticketNumbers={item.tickets}
                countTicketNumber={item.count_tickets}
                biletler={item.biletler || []}
                iptalSuresiSaat={item.iptal_suresi_saat}
                onIptal={biletIptal}
              />
            )
          })
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Empty theatre={true} />
          </div>
        )}
      </div>
      <TubitakWarningModal show={warningModalOpen.active} onHide={() => setWarningModalOpen({ state: '', active: false })} state={warningModalOpen.state} message={warningModalOpen.message} />
    </>
  )
}

export default HistoryPage
